import { ColumnDef } from "@tanstack/react-table";
import { PriceListItem } from "@/app/types/pricing";
import { Button } from "@/components/ui/button";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DataTableColumnHeader } from "@/components/ui/data-table-column-header";
import { Checkbox } from "@/components/ui/checkbox";

// Custom event dispatchers for actions
export const dispatchPriceListItemEvent = (eventName: string, detail: PriceListItem): void => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const columnsPriceListItem: ColumnDef<PriceListItem>[] = [
  {
    accessorKey: "item.name",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Item Name" />,
    cell: ({ row }) => <div className="font-medium">{row.original.item?.name ?? 'N/A'}</div>,
  },
  {
    accessorKey: "item.code",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Item Code" />,
    cell: ({ row }) => <span>{row.original.item?.code ?? '-'}</span>,
  },
  {
    accessorKey: "rate",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Rate" />,
    cell: ({ row }) => <span>{row.original.rate?.toLocaleString() ?? '-'}</span>,
  },
  {
    accessorKey: "discount_percent",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Disc %" />,
    cell: ({ row }) => <span>{row.original.discount_percent?.toLocaleString() ?? '-'}%</span>,
  },
  {
    accessorKey: "discount_amount",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Disc Amt" />,
    cell: ({ row }) => <span>{row.original.discount_amount?.toLocaleString() ?? '-'}</span>,
  },
  {
    accessorKey: "min_qty",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Min Qty" />,
    cell: ({ row }) => <span>{row.original.min_qty?.toLocaleString() ?? '0'}</span>,
  },
  {
    accessorKey: "max_qty",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Max Qty" />,
    cell: ({ row }) => <span>{row.original.max_qty?.toLocaleString() ?? 'Any'}</span>,
  },
  {
    accessorKey: "is_tax_inclusive",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Tax Incl." />,
    cell: ({ row }) => (
      <Checkbox checked={row.original.is_tax_inclusive} disabled className="ml-auto mr-auto"/>
    ),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const priceListItem = row.original;
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => dispatchPriceListItemEvent("edit-pricelist-item", priceListItem)}
            >
              <Pencil className="mr-2 h-4 w-4" />
              <span>Edit Pricing</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer text-destructive"
              onClick={() => dispatchPriceListItemEvent("remove-pricelist-item", priceListItem)}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              <span>Remove from List</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
]; 